import {
	type Control,
	Controller,
	type FieldPathByValue,
	type FieldValues,
} from "react-hook-form";
import { ContractPicker } from "web_myplann/Portfolio/Components/Redesign/Documents/ContractPicker";
import type { LinkableItemOption } from "web_myplann/Portfolio/Types/linkableItemOption";

type Props<
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: FieldPathByValue<FormType, LinkableItemOption | null>;
	label: string;
	placeholder: string;
	options: LinkableItemOption[];
	isLast?: boolean;
};

export const ContractFormPicker = <
	FormType extends FieldValues,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	...rest
}: Props<FormType, TContext, TTransformed>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange } }) => (
			<ContractPicker {...rest} value={value} onChange={onChange} />
		)}
	/>
);
